/************************************************************************************
  Lincoln Learning Portal Configuration
*************************************************************************************/

export const config = {
  userPoolScope: "lote" as const,
  styledText: "Lincoln Learning Portal",
  applicationName: "Abraham Lincoln Digital Companion",
  companyName: "BRI",
  shortName: "AL",
  appName: "Lincoln Learning Portal",
  showHomeTab: false,
  showAdminTabs: false,
  showConversationResults: true,
  showCompanionSettings: true,
  showResponseLengthOnly: true,
  showNewChatButton: true,
  showGoalChecklist: false,
  hideChatToolsForUsersOnly: false,
  customTabs: [
    { label: "About Lincoln", path: "/learn/about", icon: "about" },
    { label: "Activities to Try", path: "/learn/activities", icon: "activities" }
  ],
  applicationSummary:
    "The Lincoln Learning Portal is an interactive portal that allows you to communicate with Abraham Lincoln through chat and call.",
  prodHostnames: [
    process.env.REACT_APP_PROD_HOSTNAME,
    "d2944yen2iny0p.cloudfront.net",
    "bri.elder-wisdom.innovation.uci.edu",
  ].filter(Boolean) as string[],
  devHostnames: [
    process.env.REACT_APP_DEV_HOSTNAME,
    "d1oc4fut3eerl1.cloudfront.net",
    "bri.elder-wisdom-dev.innovation.uci.edu",
  ].filter(Boolean) as string[],
  learningPersonaId: process.env.REACT_APP_LEARNING_PERSONA_ID || 'p808bcee3af2',
};

export const exampleQuestions = [
  "Who are you?",
  "Tell me about your early life in Kentucky and Illinois.",
  "What were your main goals during the Civil War?",
  "How did you educate yourself without formal schooling?",
];

// Fallback Cognito parameters specific to Lincoln if env vars are unset
const rawWebUrl = process.env.REACT_APP_WEB_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000");
const webUrl = rawWebUrl.endsWith('/') ? rawWebUrl : `${rawWebUrl}/`;

export const awsConfig = {
  REGION: process.env.REACT_APP_REGION || "us-west-2",
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID || "us-west-2_LincolnDefaultPool",
  USER_POOL_APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID || "lincolnclientidfallback",
  API_URL: (process.env.REACT_APP_API_URL || "https://api.lincoln.avatar.platform").replace(/\/+$/, ''),
  WEB_URL: webUrl,
  AUTH_DOMAIN: (process.env.REACT_APP_AUTH_DOMAIN || "auth.lincoln.avatar.platform").replace(/^https?:\/\//, ''),
};
